import { cn } from '@/lib';
import { format } from 'date-fns';
import { enIN } from 'date-fns/locale';

interface EventDescriptionProps {
  isRecurringEvent: boolean;
  name: string;
  dateString: string;
  eventDate: number;
  eventTime: string;
  eventAddress: string;
  ticketPriceDisplay: string;
  isDateLong: boolean;
  startDate: number;
}

const EventDescription = ({
  isRecurringEvent,
  isDateLong,
  name,
  dateString,
  eventDate,
  eventTime,
  eventAddress,
  ticketPriceDisplay,
  startDate,
}: EventDescriptionProps) => {
  const date = [
    isRecurringEvent || isDateLong
      ? dateString
      : format(
        isNaN(Number(eventDate)) ? eventDate : Number(eventDate) || Number(startDate),
        'EEE d LLL yyyy',
        { locale: enIN },
      ),
    eventTime || null,
  ]
    ?.filter((item) => item)
    ?.join(' | ');

  return (
    <section className='flex flex-col gap-1 p-4'>
      <p className='text-xs font-semibold tracking-wide text-[#9A3F3F]'>
        {date || ''}
      </p>
      <h3
        className={cn('text-base leading-5 font-bold text-zinc-700', {
          truncate: true,
        })}
      >
        {name}
      </h3>
      <div className='flex items-center'>
        <p
          className={cn(
            'text-[12px] font-semibold tracking-wide text-gray-500',
            {
              truncate: true,
            },
          )}
        >
          {eventAddress}
        </p>
      </div>

      <p className='text-sm font-bold text-zinc-600 uppercase'>
        {ticketPriceDisplay}
      </p>
    </section>
  );
};

export default EventDescription;
